(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeDeleteController',PracticeDeleteController);

    PracticeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Practice'];

    function PracticeDeleteController($uibModalInstance, entity, Practice) {
        var vm = this;

        vm.practice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Practice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
